import script from "./ProductTrackModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductTrackModal.vue?vue&type=script&setup=true&lang=js"

import "./ProductTrackModal.vue?vue&type=style&index=0&id=27a245ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27a245ad"]])

export default __exports__